import React, { useEffect, useState, useRef } from 'react';
import Styled from 'styled-components';
import {loader} from 'helpers/generic';
import {default as ClockingsService} from 'services/Clockings';

const PopupStyled = Styled.div`
    position: relative;

    .btn-wrapper {
        text-align: center;
    }

    .gps-popup {
        width: 200px;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        position: absolute;
        right: 50%;
        padding: 10px;
        z-index: 1000;
        user-select: none;
    }

    table {

        thead, tbody {

            tr {

                td, th {
                    padding: 5px 10px;
                }
            }
        }
    }
`;

export default function GpsPopup(props) {
    const {employeeId, date} = props;

    const ref = useRef(null);

    const [opened, setOpened] = useState(false);
    const [loading, setLoading] = useState(false);
    const [chronometers, setChronometers] = useState(null);

    const togglePopup = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setOpened(!opened);
    }

    useEffect(() => {
        document.addEventListener('click', (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpened(false);
            }
        }, { once: true });
    }, [opened]);

    useEffect(() => {
        if (opened) {
            const getData = async () => {
                setLoading(true);
                
                const chronometers = await ClockingsService.getDispenserChronometers(employeeId, date);
                setChronometers(chronometers);

                setLoading(false);
            }
            getData();
            
        } else {
            setChronometers(null);
        }
    }, [opened, employeeId, date]);

    return (
        <PopupStyled ref={ref} onClick={e => e.stopPropagation()}>
            <div className="btn-wrapper">
                <button className="btn btn-sm btn-plenoil-outline-blue d-flex flex-row flex-nowrap gap-2 align-items-center px-2 py-0" style={{ width: 26, height: 26, minWidth: 0, borderRadius: '1.5rem', paddingTop: '0 !important' }} onClick={e => togglePopup(e)}><i className="bi bi-globe"></i></button>
            </div>
            {opened &&
                <div className="gps-popup">
                    {loading && loader}

                    {(!loading && chronometers) &&
                        <table>
                            <thead>
                                <tr>
                                    <th>Entrada</th>
                                    <th>Salida</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chronometers.map((chronometer, index) => (
                                    <tr key={index}>
                                        <td>
                                            {chronometer.start_at}&nbsp;
                                            {chronometer.start_at_latitude && chronometer.start_at_longitude &&
                                                <a href={`https://www.google.com/maps/search/?api=1&query=${chronometer.start_at_latitude},${chronometer.start_at_longitude}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="bi bi-geo-alt"></i>
                                                </a>
                                            }
                                        </td>
                                        <td>
                                            {chronometer.end_at ?? ''}&nbsp;
                                            {chronometer.end_at_latitude && chronometer.end_at_longitude &&
                                                <a href={`https://www.google.com/maps/search/?api=1&query=${chronometer.end_at_latitude},${chronometer.end_at_longitude}`} target="_blank" rel="noopener noreferrer">
                                                    <i className="bi bi-geo-alt"></i>
                                                </a>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>
            }
        </PopupStyled>
    );
}